// Public: Wraps a function, passing `this` as the first argument, and
// delegating the rest of the arguments.
export function curryThis (func) {
  return function (...args) {
    return func(this, ...args)
  }
}
